<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_from"
          :label="$t('fields.date_from')"
          :clearable="true"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_to"
          :label="$t('fields.date_to')"
          :clearable="true"
        />
      </v-flex>
      <v-flex xs2 class="mt-6 ml-2">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          :label="$t('fields.propagandist')"
        />
      </v-flex>
      <v-flex xs3 class="mt-3 ml-2">
        <AutoComplete
          :value="searchSchool"
          v-model="searchSchool"
          key-value="id"
          key-name="fullname"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="schools"
          :label="$t('fields.school')"
          @search="searchSchools"
          @input="fetchSchoolsIfExist"
          @clear="deleteSelectedSchools"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
      </v-flex>
      <v-flex xs1 class="mt-6 ml-2">
        <v-text-field
          v-model="filters.order_number"
          label="N. Ordine"
          clearable
          type="number"
        />
      </v-flex>
      <v-spacer></v-spacer>

    </v-row>
    </v-container>
    <v-row>
    <v-col
      cols="12"
    >

    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:[`item.order_number`]="{ item }">
            {{ item.campaign_book.order_number }}
      </template>

      <template v-slot:[`item.teachers.surname`]="{ item }">
            {{ item.teacher.fullname }}
      </template>

      <template v-slot:[`item.title`]="{ item }">
            {{ item.book.title }}
      </template>

      <template v-slot:[`item.isbn`]="{ item }">
            {{ item.book.isbn }}
      </template>

      <template v-slot:[`item.author`]="{ item }">
            {{ item.book.author }}
      </template>

      <template v-slot:[`item.volume`]="{ item }">
            {{ item.book.volume }}
      </template>

      <template v-slot:[`item.book_type`]="{ item }">
            {{ item.book.book_type }}
      </template>

      <template v-slot:[`item.editor`]="{ item }">
            {{ item.editor.name }}
      </template>

      <template v-slot:[`item.school`]="{ item }">
            {{ item.school.name }}
      </template>

      <template v-slot:[`item.shipping_type`]="{ item }">
           {{ $t(`delivery_methods.${item.campaign_book.shipping_type}`) }}
      </template>

      <template v-slot:[`item.campaign_book.updated_at`]="{ item }">
          {{ getLastStatus(item.campaign_book.statuses).updated_at | timeFormat }}
      </template>

    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchOrdered"
    />
    </v-col>
    </v-row>
  </div>
  </v-flex>
</template>
<script>

  import { campaignsReportService } from '../../../utils/services/campaignsReport.service';

  import { schoolsService } from '../../../utils/services/schools.service';

  import { DeliveryMethods } from '../../../utils/constants/delivery-methods';

  import InputDataPicker from '../../../components/shared/Inputs/InputDataPicker.vue';
  import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
  import PropagandistSelect from '../../../components/shared/Vselects/PropagandistSelect.vue';
  import Paginator from '../../../components/shared/Paginator';

  export default {
    name: 'CampaignReportOrdered',
    components: {
      InputDataPicker,
      AutoComplete,
      PropagandistSelect,
      Paginator,
    },
    data() {
      return {
        loading: false,
        schools: [],
        searchSchool: null,
        searchSchoolsValue: null,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['campaign_book.created_at'],
        },

        headers: [
          { text: 'N. Ordine', value: 'order_number', sortable: false },
          { text: this.$t('fields.teacher'), value: 'teachers.surname' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume' },
          { text: this.$t('fields.editor'), value: 'editor' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.type_shipping'), value: 'shipping_type' },
          { text: this.$t('fields.book_type'), value: 'book_type' },
          { text: this.$t('fields.school'), value: 'school' },
          { text: this.$t('fields.updated_at'), value: 'campaign_book.updated_at' },
        ],
        filters: {
          date_from: null,
          date_to: null,
          schoolId: 0,
          propagandist_id: 0,
          shipping_type: [DeliveryMethods.HOME, DeliveryMethods.SCHOOL],
          order_number: null,
        },
      };
    },
    computed: {

      requestFilters() {
        const filters = {
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
          school_id: this.filters.schoolId,
          propagandist_id: this.filters.propagandist_id,
          shipping_type: this.filters.shipping_type,
          order_number: this.filters.order_number,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {

      deleteSelectedSchools() {
        this.filters.schoolId = 0;
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
        } else {
          this.filters.schoolId = 0;
        }
      },

      fetchSchools() {
        return schoolsService.index({
          filters: {
            search: this.searchSchoolsValue,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchOrdered(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return campaignsReportService.bookReportOrdered({
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async searchSchools(val) {
        this.searchSchoolsValue = val;
        await this.fetchSchools();
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },

    },
    async created() {
      await this.fetchOrdered(1);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchOrdered(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchOrdered(1);
          }
        },
      },

    },
  };
</script>
